var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4426 23.5429C18.1393 23.5429 17.8243 23.5313 17.486 23.4963C16.8793 23.4496 16.191 23.3329 15.4793 23.1579L13.5193 22.6913C8.14098 21.4196 6.37931 18.5729 7.63931 13.2063L8.78264 8.31794C9.03931 7.20962 9.34264 6.31129 9.71598 5.56462C11.7226 1.42295 15.561 1.79627 18.291 2.43794L20.2393 2.89294C22.9693 3.53461 24.696 4.54961 25.6643 6.10129C26.621 7.65295 26.7726 9.64794 26.131 12.3779L24.9876 17.2546C23.9843 21.5246 21.896 23.5429 18.4426 23.5429ZM15.3043 3.79127C13.356 3.79127 12.1193 4.59629 11.291 6.32295C10.9876 6.95295 10.7193 7.73461 10.486 8.71461L9.34264 13.6029C8.30431 18.0129 9.50598 19.9379 13.916 20.9879L15.876 21.4546C16.506 21.6063 17.101 21.6996 17.6376 21.7463C20.811 22.0613 22.386 20.6729 23.2726 16.8579L24.416 11.9813C24.941 9.72962 24.871 8.15462 24.171 7.02294C23.471 5.89127 22.0943 5.12129 19.831 4.59629L17.8826 4.14127C16.9143 3.90794 16.051 3.79127 15.3043 3.79127Z",
    fill: "url(#paint0_linear_2254_121358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6234 13.7522C10.9198 11.1277 13.2878 9.24034 15.9124 9.5368C18.537 9.83327 20.4243 12.2013 20.1278 14.8258C20.0032 15.929 19.5126 16.902 18.7908 17.6372C18.8974 17.679 18.9948 17.7486 19.0713 17.8446L20.203 19.2645C20.435 19.5556 20.3871 19.9796 20.096 20.2117C19.8049 20.4437 19.3808 20.3958 19.1488 20.1047L18.0171 18.6848C17.9406 18.5888 17.8945 18.4783 17.8776 18.365C16.9998 18.9047 15.942 19.1659 14.8388 19.0413C12.2142 18.7448 10.3269 16.3768 10.6234 13.7522ZM15.7611 10.8764C13.8763 10.6635 12.1758 12.0188 11.9629 13.9035C11.75 15.7883 13.1053 17.4888 14.9901 17.7017C16.8748 17.9146 18.5754 16.5593 18.7883 14.6745C19.0012 12.7898 17.6458 11.0893 15.7611 10.8764Z",
    fill: "url(#paint1_linear_2254_121358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6883 14.0569C16.6631 14.0609 16.6373 14.0606 16.6073 14.0611L14.4921 13.8664C14.3178 13.851 14.19 13.6949 14.2054 13.5206C14.2209 13.3462 14.3769 13.2184 14.5513 13.2339L16.6664 13.4286C16.8408 13.444 16.9685 13.6 16.9531 13.7744C16.9414 13.9181 16.8266 14.035 16.6883 14.0569Z",
    fill: "url(#paint2_linear_2254_121358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6836 15.6683C15.6585 15.6723 15.6327 15.6721 15.6027 15.6725L14.3334 15.5549C14.1591 15.5394 14.0313 15.3834 14.0468 15.209C14.0622 15.0347 14.2182 14.9069 14.3926 14.9224L15.6618 15.04C15.8362 15.0555 15.9639 15.2115 15.9485 15.3858C15.9374 15.5337 15.8262 15.6458 15.6836 15.6683Z",
    fill: "url(#paint3_linear_2254_121358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71709 25.959C6.71877 25.959 4.80542 24.1623 3.58042 20.3706L2.08709 15.7623C0.430428 10.6289 1.91209 7.73561 7.02209 6.07894L8.86542 5.48394C9.47209 5.29727 9.92709 5.16894 10.3354 5.09894C10.6738 5.02894 11.0004 5.15727 11.1988 5.42561C11.3971 5.69394 11.4321 6.04394 11.2921 6.34727C10.9888 6.96561 10.7204 7.74727 10.4988 8.72727L9.35543 13.6156C8.3171 18.0256 9.51876 19.9506 13.9288 21.0006L15.8888 21.4673C16.5188 21.619 17.1138 21.7123 17.6505 21.759C18.0238 21.794 18.3271 22.0506 18.4321 22.4123C18.5255 22.774 18.3855 23.1473 18.0821 23.3573C17.3121 23.8823 16.3438 24.3256 15.1188 24.7223L13.2755 25.329C11.9338 25.749 10.7671 25.959 9.71709 25.959ZM9.07543 7.25727L7.57042 7.74727C3.40542 9.08894 2.41376 11.0489 3.75542 15.2256L5.24876 19.834C6.60209 23.999 8.5621 25.0023 12.7271 23.6606L14.5705 23.054C14.6405 23.0306 14.6988 23.0073 14.7688 22.984L13.5321 22.6923C8.15377 21.4206 6.39209 18.574 7.65209 13.2073L8.79542 8.31894C8.8771 7.94561 8.97042 7.58394 9.07543 7.25727Z",
    fill: "url(#paint4_linear_2254_121358)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8618 12.1316L21.1524 11.5489C19.8532 11.1061 19.1603 9.69645 19.6031 8.3973L20.1858 6.6879C20.3052 6.33747 20.6949 6.14593 21.0453 6.26538C21.3958 6.38482 21.5873 6.77448 21.4678 7.1249L20.8852 8.83431C20.6842 9.42405 20.9996 10.0658 21.5894 10.2669L23.2988 10.8495C23.6492 10.969 23.8408 11.3586 23.7213 11.709C23.6019 12.0595 23.2122 12.251 22.8618 12.1316Z",
    fill: "url(#paint5_linear_2254_121358)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2254_121358",
    x1: 16.885,
    y1: 2.04297,
    x2: 16.885,
    y2: 23.5429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2254_121358",
    x1: 16.2951,
    y1: 9.58004,
    x2: 15.135,
    y2: 19.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2254_121358",
    x1: 15.4891,
    y1: 13.0761,
    x2: 15.6693,
    y2: 14.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2254_121358",
    x1: 14.9236,
    y1: 14.8288,
    x2: 15.0714,
    y2: 15.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2254_121358",
    x1: 9.95033,
    y1: 5.08008,
    x2: 9.95033,
    y2: 25.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2254_121358",
    x1: 22.7547,
    y1: 6.84805,
    x2: 21.1524,
    y2: 11.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTransaction);
export default __webpack_public_path__ + "static/media/search-transaction.4495bf85c5a8963091f044601c8229d6.svg";
export { ForwardRef as ReactComponent };